import { render, staticRenderFns } from "./house-item.vue?vue&type=template&id=b30ab9b8&scoped=true&"
import script from "./house-item.vue?vue&type=script&lang=js&"
export * from "./house-item.vue?vue&type=script&lang=js&"
import style0 from "./house-item.vue?vue&type=style&index=0&id=b30ab9b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30ab9b8",
  null
  
)

export default component.exports